import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, Box, Skeleton } from '@mui/material';
import { getScoreByAffinity } from '../../../../redux/thunks/affinityHubThunk';
import { HeatMapChart } from '../../../shared';
import { AFFINITY_HEAT_MAP_CHART_OPTIONS } from './constants';
import './channelAffinity.css';

export default function ChannelAffinity(props) {
    const { } = props;
    const dispatch = useDispatch();
    const { affinity } = useSelector((state) => state.affinityHub);
    const {
        digital, personalPromotion, peerToPeer, isLoading 
    } = affinity;
    const [digitalData,setDigitalData] = useState([]);
    const [peerTopeerData,setpeerTopeerData] = useState([]);
    const [personalData,setPersonalData] = useState([]);
    useEffect(()=> {
        dispatch(getScoreByAffinity());
    }, []);
    useEffect(()=>{
        setDigitalData(digital.chartSeries);
    },[digital]);
    useEffect(()=>{
        setpeerTopeerData(peerToPeer.chartSeries);
    },[peerToPeer]);
    useEffect(()=>{
        setPersonalData(personalPromotion.chartSeries);
    },[digital]);
    return (
        <Grid container className="box-sizing-border-box flex-row br-16px">
            {/*  Digital Affinity */}
            <Grid
                item className="digital-affinity-heat-map-container pie-chart-affinity-tooltip" lg={4} md={12} sm={12} xl={4}
                xs={12}
            >
                <Box className="flex-row-space-between">
                    <Box>
                        <Typography className='text-md-semi-bold gray-900'>
                            Digital Affinity
                        </Typography>
                    </Box>
                </Box>

                {isLoading ? <Skeleton height={300} /> :(
                    <HeatMapChart
                        chartOptions={
                            {
                                ...AFFINITY_HEAT_MAP_CHART_OPTIONS,
                                plotOptions: {
                                    ...AFFINITY_HEAT_MAP_CHART_OPTIONS.plotOptions,
                                    heatmap: {
                                        ...AFFINITY_HEAT_MAP_CHART_OPTIONS.plotOptions.heatmap,
                                        colorScale: {
                                            ...AFFINITY_HEAT_MAP_CHART_OPTIONS.plotOptions.heatmap.colorScale,
                                            ranges: digital.chartRange
                                        }
                                    }
                                }
                            }
                        }
                        chartSeries={digitalData}
                    />
                )}
            </Grid>
            {/* Personal Promotion Affinity */}
            <Grid item className="personal-affinity-heat-map-container pie-chart-affinity-tooltip" lg={4} md={12} sm={12} xl={4}
                xs={12}
            >
                <Box className="flex-row-space-between">
                    <Box>
                        <Typography className='text-md-semi-bold gray-900'>
                            Personal Promotion Affinity
                        </Typography>
                    </Box>
                </Box>
                {isLoading ? <Skeleton height={300} /> : (
                    <HeatMapChart
                        chartOptions={
                            {
                                ...AFFINITY_HEAT_MAP_CHART_OPTIONS,
                                plotOptions: {
                                    ...AFFINITY_HEAT_MAP_CHART_OPTIONS.plotOptions,
                                    heatmap: {
                                        ...AFFINITY_HEAT_MAP_CHART_OPTIONS.plotOptions.heatmap,
                                        colorScale: {
                                            ...AFFINITY_HEAT_MAP_CHART_OPTIONS.plotOptions.heatmap.colorScale,
                                            ranges: personalPromotion.chartRange
                                        }
                                    }
                                }
                            }
                        }
                        chartSeries={personalData}
                    />
                )}
            </Grid>
            {/* Peer to Peer Affinity */}
            <Grid item className="peer-affinity-heat-map-container pie-chart-affinity-tooltip" lg={4} md={12} sm={12} xl={4}
                xs={12}
            >
                <Box className="flex-row-space-between">
                    <Box>
                        <Typography className='text-md-semi-bold gray-900'>
                            Peer to Peer Affinity
                        </Typography>
                    </Box>
                </Box>
                {isLoading ? <Skeleton height={300} /> :(
                    <HeatMapChart
                        chartOptions={
                            {
                                ...AFFINITY_HEAT_MAP_CHART_OPTIONS,
                                plotOptions: {
                                    ...AFFINITY_HEAT_MAP_CHART_OPTIONS.plotOptions,
                                    heatmap: {
                                        ...AFFINITY_HEAT_MAP_CHART_OPTIONS.plotOptions.heatmap,
                                        colorScale: {
                                            ...AFFINITY_HEAT_MAP_CHART_OPTIONS.plotOptions.heatmap.colorScale,
                                            ranges: peerToPeer.chartRange
                                        }
                                    }
                                }
                            }
                        }
                        chartSeries={peerTopeerData}
                    />
                )}
            </Grid>
        </Grid>
    );
}
